import { SimpleSelectField } from '@navinc/base-react-components/wayfinder'

import { cmsGraphql, FragmentType, getFragmentData } from '../../../lib/cms/index.js'
import { ValidationError } from '../types.js'

export const timeInBusinessFragment = cmsGraphql(/* GraphQL */ `
  fragment timeInBusinessFragment on CmsTimeInBusinessFormField {
    name
    label
    required
  }
`)

export type TimeInBusinessSelectProps = {
  data: FragmentType<typeof timeInBusinessFragment>
  validationError?: ValidationError
}

const timeInBusinessOptions: { label: string; value: string }[] = [
  { label: 'Just Starting', value: 'Just Starting' },
  { label: '0-5 months', value: '0-5 months' },
  { label: '6-11 months', value: '6-11 months' },
  { label: '1-2 years', value: '1-2 years' },
  { label: '2-5 years', value: '2-5 years' },
  { label: '5-10 years', value: '5-10 years' },
  { label: '10+ years', value: '10+ years' },
]

export const TimeInBusinessSelect = ({ data, validationError }: TimeInBusinessSelectProps) => {
  const { name, label, required } = getFragmentData(timeInBusinessFragment, data)
  return (
    <SimpleSelectField
      name={name ?? undefined}
      label={label}
      defaultValue={undefined}
      required={required ?? undefined}
      error={validationError?.data?.errors?.find((error) => error.path === name)?.message}
      options={timeInBusinessOptions}
    />
  )
}
